module.exports = __webpack_public_path__ + "static/img/20240912_1.4145543.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20240912_1.png
// module id = C1dG
// module chunks = 0